import React, { ReactNode } from 'react';
import { Button, ButtonGroup, Heading, ModalDialog, Paragraph, TextButton, Trigger } from '@zillow/constellation';

interface IConfirmDeleteModalDialogProps {
  onConfirmation: () => void;
  message: ReactNode;
  title: string;
  triggerElement: ReactNode;
}

export const ConfirmDeleteModalDialog: React.FC<IConfirmDeleteModalDialogProps> = ({
  onConfirmation,
  message,
  title,
  triggerElement,
}) => {
  return (
    <Trigger
      triggered={({ isOpen, onClose }, close) => (
        <ModalDialog
          isOpen={isOpen}
          onClose={onClose}
          renderHeader={<Heading level="6">{title}</Heading>}
          renderBody={<Paragraph>{message}</Paragraph>}
          renderFooter={
            <ButtonGroup aria-label="Modal actions">
              <TextButton onClick={close}>Cancel</TextButton>
              <Button
                buttonType="primary"
                onClick={() => {
                  onConfirmation();
                  close();
                }}
              >
                Confirm Delete
              </Button>
            </ButtonGroup>
          }
        />
      )}
    >
      {triggerElement}
    </Trigger>
  );
};
